import { createSelector } from "reselect"

export const irrSample = createSelector(
  (state) => state.irrSample.irrSample,
  (sample) => sample || {}
)

export const irrReview = createSelector(
    (state) => state.irrSample.irrReview,
    (review) => review || {}
)

export const irrType = createSelector(irrSample, ({ irrType }) => ({
  mqd: irrType === "MQD",
  hsag: irrType === "HSAG",
}))

export const irrSampleGridData = createSelector(irrSample, (sample) => {
  if (sample && sample.reviews) {
    const data = sample.reviews.map((r) => ({
      id: r.id,
      periodId: sample.periodId,
      recordId: r.patientRecordReview.recordId,
      sampleId: sample.id,
      name: r.patientRecordReview.record.name,
      dateOfBirth: r.patientRecordReview.record.dateOfBirth,
      admitDate: r.patientRecordReview.record.admissionDate,
      facility: r.patientRecordReview.record.facilityName,
      medicaidId: r.patientRecordReview.record.medicaidId,
      q1: capitalizeYesNo(r.q1),
      q2: capitalizeYesNo(r.q2),
      q3: capitalizeYesNo(r.q3),
      q4: capitalizeYesNo(r.q4),
      q5: capitalizeYesNo(r.q5),
    }));

    return [...data].sort((a, b) => a.name > b.name ? 1 : -1 );
  } else {
    return []
  }
})

const capitalizeYesNo = (value) => {
  if (value === 'yes') {
    return 'Yes';
  } else if (value === 'no') {
    return 'No';
  } else {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/modules/irr-sample/irr-sample.selectors.js